import { getTourTypePending, getTourTypeSuccess, getTourTypeFail, 
    deleteTourTypePending, deleteTourTypeSuccess, deleteTourTypeFail,
    getSTourTypePending, getSTourTypeSuccess, getSTourTypeFail, 
    createTourTypePending, createTourTypeSuccess, createTourTypeFail, 
    modifyTourTypePending, modifyTourTypeSuccess, modifyTourTypeFail } from "./TourTypeSlice";
import { fetchAllTourType, tourTypeDelete, tourTypeCreation, tourTypeModify, fetchSingleTourType } from "../../../api/userApi";

export const getAllTourType = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getTourTypePending());
        const result = await fetchAllTourType();
        const myJSON = JSON.stringify(result);
        const myObj = JSON.parse(myJSON);
        const tourTypedetails = JSON.parse(JSON.stringify(myObj.tourtypes));
        const tourTypedetails1 = JSON.parse(JSON.stringify(tourTypedetails));
        
        if (tourTypedetails) {
        
            return dispatch(getTourTypeSuccess(tourTypedetails));
        }
        dispatch(getTourTypeFail("Tour Type is not found"));


    } catch (error) {
       //console.log(error.msg);
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getTourTypeFail(err.msg));

    }
}

export const tourTypeDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteTourTypePending());
        const result = await tourTypeDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deleteTourTypeSuccess("Tour Type deleted"))
        : dispatch(deleteTourTypeFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteTourTypeFail(err.msg));
    }
    
}

export const newTourTypeCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createTourTypePending());
        const result = await tourTypeCreation(frmDt);
        //console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createTourTypeSuccess(result.message))
            : dispatch(createTourTypeFail(result.message));

           // console.log("CountryCreation "+result);
            // console.log("try block");
           // console.log(result.status);
           // console.log('actions '+result.message);

    } catch (error) {
         //console.log("catch block");
         console.log(error);
         if(error.response.status===401){}
        const err = JSON.parse(JSON.stringify(error.response.data.errors));
       //  console.log(err);
        // console.log('disp');
        // console.log(err.msg);
       
       const row = err.map((er, i) => {
        console.log('loop');
        console.log(er.msg);
        console.log('loop param');

        console.log(er.param);
            if (i === er.length - 1) {
              return er.param+' '+er.msg+'. ';
            }
            return er.param+' '+er.msg+' ';
          });
          console.log('row');
          console.log(row);
          dispatch(createTourTypeFail(row));
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
       
       
       
    }

}

export const getSingleTourType = (id) => async (dispatch) => {
    
 
 
    try {
     //call the api
    dispatch(getSTourTypePending());
    const result = await fetchSingleTourType(id);

 
 //console.log('check user profile out if');
    if(result.tourtypes[0] && result.tourtypes[0].id){
    //console.log('check user profile');
        return dispatch(getSTourTypeSuccess(result.tourtypes[0]));
    }
    dispatch(getSTourTypeFail("Tour Type is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
    console.log(err.msg);
    dispatch(getSTourTypeFail(err.msg));
 
 }
    
 
 }




export const tourTypeModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyTourTypePending());
        const result = await tourTypeModify(frmDt);
        result.status === "success"
            ? dispatch(modifyTourTypeSuccess(result.message))
            : dispatch(modifyTourTypeFail(result.message));

          //  console.log("userRoleModify "+result);
            // console.log("try block");
            //console.log(result.status);
            //console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyTourTypeFail(err.msg));
    }

}
